import React, { useState, useEffect } from 'react';
// Permissions
import { saveCustomerInfo } from '../../store/actions/AuthAction';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Fragment } from 'react';
import { toast } from 'react-toastify';
import { handleLogoutCookie } from '../utils/cookies';
import { checkPermission } from './checkPermission';
// Permissions

const ElementCheckPermissionWrapper = (props) => {
    // permissions

    const header = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept, Authorization, Content-Disposition',
        'Access-Control-Expose-Headers': 'Content-Disposition',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, HEAD, OPTIONS',
        'Access-Control-Allow-Credentials': 'true',
        Authorization: props.token,
    };

    let history = useHistory();

    const [actionData, setActionData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [permissionData, setPermissionData] = useState({
        action: [],
        hasPermission: false,
        hasService: false,
    });

    const actions = {
        CREATE: actionData.includes('CREATE'), // thêm mới
        COPY: actionData.includes('COPY'), // sao chép
        SAVE_TEMPLATE: actionData.includes('SAVE_TEMPLATE'), // Lưu tạm
        SAVE_COMPLETE: actionData.includes('SAVE_COMPLETE'), // Hoàn thành
        UPDATE: actionData.includes('UPDATE'), // chỉnh sửa
        CHANGE_STATUS: actionData.includes('CHANGE_STATUS'), // cập nhật trạng thái
        EXPORT_EXCEL: actionData.includes('EXPORT_EXCEL'), // xuất excel
        IMPORT_EXCEL: actionData.includes('IMPORT_EXCEL'), // nhập excel
        CANCEL: actionData.includes('CANCEL'), // hủy
        DELETE: actionData.includes('DELETE'), // xóa
        APPROVED: actionData.includes('APPROVED'), // duyệt
        DETAIL: actionData.includes('DETAIL'), // chi tiết
        LIST: actionData.includes('LIST'), // danh sách
        REFUSE: actionData.includes('REFUSE'), // Từ chối duyệt
        PENDING: actionData.includes('PENDING'), // chờ duyệt
        PRINT: actionData.includes('PRINT'), // in
        PRINT_REPORT: actionData.includes('PRINT_REPORT'), // in báo cáo đơn hàng
        PAUSED: actionData.includes('PAUSED'), // tạm dừng
        CONTINUE: actionData.includes('CONTINUE'), // tiếp tục
        DOWNLOAD_FILE: actionData.includes('DOWNLOAD_FILE'), // tải file mẫu
        IMPORT: actionData.includes('IMPORT'), // nhận hàng
        BARTENDER: actionData.includes('BARTENDER'), // pha chế
        PREPARE: actionData.includes('PREPARE'), // chuẩn bị hàng
        CONFIRMATION_REPORT: actionData.includes('CONFIRMATION_REPORT'), // biên bản xác nhận
        IMPORT_EXPECT: actionData.includes('IMPORT_EXPECT'), // nhập dự kiến
        BACK_ORDER: actionData.includes('BACK_ORDER'),
        BACK_ORDER_CREATE: actionData.includes('BACK_ORDER_CREATE'),
        MATERIAL_GENERAL: actionData.includes('MATERIAL_GENERAL'),
        UPDATE_PROVIDER: actionData.includes('UPDATE_PROVIDER'), // Cập nhật nhà cung cấp
        CHANGE_TIME: actionData.includes('CHANGE_TIME'), // Cập nhật thời gian
        EXPORT_INVOICE: actionData.includes('EXPORT_INVOICE'), // Xuất hóa đơn
    };

    const handleLogout = (message) => {
        toast.error(message);
        history.push('/');
        props.saveCustomerInfo({ token: '', fullName: '' });
        handleLogoutCookie();
    };

    const handleCheckPermission = async () => {
        const result = await checkPermission(header);

        setPermissionData(result);

        if (result.hasService) {
            if (result.hasPermission) {
                setActionData(result.action);
            }
        }
        setIsLoading(true);
    };

    const currentURL = window.location.href;
    const url = new URL(currentURL);
    const domain = url.origin;
    const link = url.pathname;

    useEffect(() => {
        if (String(link) === '/') {
            history.push('/');
        } else {
            handleCheckPermission();
        }
    }, [domain, link]);

    // permissions
    return (
        <Fragment>
            {isLoading && permissionData.hasService &&
                permissionData.hasPermission &&
                React.Children.map(props.children, (child) => {
                    return React.cloneElement(child, { actions: actions, handleLogout: handleLogout });
                })}
        </Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        token: state.authReducer.detail.token,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveCustomerInfo: (data) => dispatch(saveCustomerInfo(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ElementCheckPermissionWrapper);
